import React, { useEffect, useRef, useState } from 'react';
import { useTierLogic } from './hooks/useTierLogic';
import { TierRow } from './TierRow';
import './styles/component-bs.css';
import { Button } from 'reactstrap';
import { T } from '../../helpers/i18n';
// ─── Icon ────────────────────────────────────────────────────────────────────
var PlusIcon = function () {
    return (React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: 2, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
        React.createElement("path", { d: "M8 3v10M3 8h10", strokeLinecap: "round" })));
};
// ─── Component ───────────────────────────────────────────────────────────────
export var PricingTierEditorCore = function (_a) {
    var categoryLabel = _a.categoryLabel, _b = _a.currency, currency = _b === void 0 ? 'EUR' : _b, maxPax = _a.maxPax, initialTiers = _a.initialTiers, passengerCategory_id = _a.passengerCategory_id, 
    // money_id,
    onChange = _a.onChange, onSave = _a.onSave;
    var _c = useTierLogic(initialTiers, maxPax), tiers = _c.tiers, addTier = _c.addTier, removeTier = _c.removeTier, updateTier = _c.updateTier, toggleTier = _c.toggleTier;
    var hostRef = useRef(null);
    var _d = useState(null), shadowRoot = _d[0], setShadowRoot = _d[1];
    // ── Stable onChange ref ────────────────────────────────────────────────────
    var onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;
    var onSaveRef = useRef(onSave);
    onSaveRef.current = onSave;
    // ── Notify parent — skip first render ─────────────────────────────────────
    var isFirstRender = useRef(true);
    useEffect(function () {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (onChangeRef.current)
            onChangeRef.current(tiers);
    }, [tiers]);
    // ── Attach Shadow DOM once on mount ───────────────────────────────────────
    /* useEffect(() => {
       if (!hostRef.current || hostRef.current.shadowRoot) return
       const sr = hostRef.current.attachShadow({ mode: 'open' })
       setShadowRoot(sr)
     }, [])*/
    return (React.createElement("div", { ref: hostRef },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "pt-editor" },
                React.createElement("p", { className: "pt-category-label" }, categoryLabel),
                React.createElement("table", { className: "pt-table", role: "table" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { className: "col-check", scope: "col", "aria-label": "Enabled" }),
                            React.createElement("th", { className: "col-range", scope: "col" }, "Range (Pax)"),
                            React.createElement("th", { className: "col-price", scope: "col" }, "Price"),
                            React.createElement("th", { className: "col-actions", scope: "col", "aria-label": "Actions" }))),
                    React.createElement("tbody", null, tiers.sort(function (a, b) {
                        // primero agrupar por passengerCategory_id
                        if (a.passengerCategory_id !== b.passengerCategory_id) {
                            return a.passengerCategory_id - b.passengerCategory_id;
                        }
                        // dentro del grupo ordenar por minPax, nulls last
                        if (a.minPax === null && b.minPax === null)
                            return 0;
                        if (a.minPax === null)
                            return 1;
                        if (b.minPax === null)
                            return -1;
                        return a.minPax - b.minPax;
                    }).map(function (tier, idx) { return (React.createElement(TierRow, { key: tier.id, tier: tier, isLast: idx === tiers.length - 1, isOnly: tiers.length === 1, currency: currency, onToggle: function () { return toggleTier(tier.id); }, onUpdateMaxPax: function (val) { return updateTier(tier.id, { maxPax: val }); }, onUpdatePrice: function (val) { return updateTier(tier.id, { price: val }); }, onDelete: function () { return removeTier(tier.id); } })); }))),
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("button", { type: "button", className: "pt-add-btn", onClick: addTier, "aria-label": "Add another pricing tier" },
                                    React.createElement(PlusIcon, null),
                                    "Add another tier")),
                            React.createElement("td", null,
                                React.createElement(Button, { type: "button", className: "pt-add-btn", onClick: function () { return onSave(tiers, passengerCategory_id); }, "aria-label": "Add another pricing tier" }, T('save'))))))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/PricingTier/PricingTierEditor.tsx
// module id = 1020
// module chunks = 0